import React from 'react';
import { Spinner } from './Spinner';

export const Loading: React.FC<{ id?: string; style?: React.CSSProperties; title?: string; spinner?: boolean; children?: React.ReactNode }> = (props) => {
    return (
        <div className="ui-loading" id={props.id} style={props.style}>
            {props.spinner && <Spinner />}
            {props.title && <div className="ui-loading-title">{props.title}</div>}
            {props.children}
        </div>
    );
};
